<template>
  <!-- Edition modal -->
  <transition name="fade" mode="out-in">
    <div class="dark-overlay v-centerer config-edition-modal" style="text-align: left">
      <div class="dark-overlay-content xlarge" style="padding: 30px;box-sizing: border-box;">
        <CloseButton style="left: 10px;" @click.native="$emit('input', null)" />

        <!-- Team edition modal -->
        <form v-if="isTeam" @submit.prevent="save">
          <h2 class="basic-sub-title">
            {{ $t('message.CONFIG_TEAM_EDITION') }}
          </h2>
          <div class="config-edition-modal__hinted-field">
            <EditableLabel
              v-model="value.name"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.NAME') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_TEAM_NAME_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <EditableLabel
              v-model="value.email"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.EMAIL') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_TEAM_EMAIL_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <div class="config-edition-modal__hinted-field__field hierarchy-wrapper">
              <EditableLabel
                v-model="value.hierarchyLevel"
                class="clickable-hoverable"
                :placeholder="$t('message.CLICK_TO_TYPE')"
                :legend="$t('message.HIERARCHY_LEVEL') + $t('message.TWO_DOTS')"
              />
              <span
                class="dot"
                :style="'background-color:' + colors[value.hierarchyLevel % colors.length].dark"
              />
            </div>
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_TEAM_HIERARCHY_LEVEL_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <EditableLabelRadio
              v-model="value.accesses"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_CHANGE')"
              :items="allUsers.filter(u => u.hierarchyLevel > value.hierarchyLevel)"
              :legend="$t('message.ACCESS') + $t('message.TWO_DOTS')"
              multiple
              separator=", "
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_TEAM_ACCESSES_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <AdvancedTeamPicker
              v-model="value.supervisorTeamIds"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :legend="$t('message.SUPERVISOR_TEAMS') + $t('message.TWO_DOTS')"
              display-all-teams
              config
              use-editable-label
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              <div>{{ $t('message.SUPERVISOR_TEAMS_HINT', value) }}</div>
              <div v-if="supervisorTeamError" class="config-edition-modal__hinted-field__hint__error">
                {{ supervisorTeamError }}
              </div>
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <AdvancedTeamPicker
              v-model="value.supervisedTeamIds"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :legend="$t('message.SUPERVISED_TEAMS') + $t('message.TWO_DOTS')"
              display-all-teams
              config
              use-editable-label
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              <div>{{ $t('message.SUPERVISED_TEAMS_HINT', value) }}</div>
              <div v-if="supervisedTeamError" class="config-edition-modal__hinted-field__hint__error">
                {{ supervisedTeamError }}
              </div>
            </div>
          </div>
          <div v-if="company.enableSaml || company.enableOidc">
            <div class="sep" />
            <div class="config-edition-modal__hinted-field">
              <EditableLabel
                v-model="value.remoteIdPId"
                class="clickable-hoverable config-edition-modal__hinted-field__field"
                :placeholder="$t('message.CLICK_TO_TYPE')"
                :legend="$t('message.CONFIG_REMOTE_IDP_ID') + $t('message.TWO_DOTS')"
              />
              <div class="field-hint config-edition-modal__hinted-field__hint">
                {{ $t('message.CONFIG_TEAM_REMOTE_IDP_ID') }}
              </div>
            </div>
          </div>
          <div>
            <div class="sep" />
            <div class="config-edition-modal__hinted-field">
              <!-- TODO: Make it disabled -->
              <EditableLabel
                v-model="value.companyInternalId"
                class="clickable-hoverable config-edition-modal__hinted-field__field"
                :placeholder="$t('message.CLICK_TO_TYPE')"
                :legend="$t('message.CONFIG_COMPANY_INTERNAL_ID') + $t('message.TWO_DOTS')"
              />
              <div class="field-hint config-edition-modal__hinted-field__hint">
                {{ $t('message.CONFIG_COMPANY_INTERNAL_ID_HINT') }}
              </div>
            </div>
          </div>
          <button type="submit" class="action-btn" style="margin: 30px auto;display: block;">
            {{ $t("message.SAVE") }}
          </button>
        </form>

        <!-- User edition modal -->
        <form v-else class="config-edition-modal" @submit.prevent="save">
          <h2 class="basic-sub-title">
            {{ $t('message.CONFIG_USER_EDITION') }}
          </h2>
          <div class="config-edition-modal__hinted-field">
            <div class="config-edition-modal__hinted-field__field">
              <EditableLabel
                v-model="value.firstName"
                class="clickable-hoverable"
                :placeholder="$t('message.CLICK_TO_TYPE')"
                :legend="$t('message.FIRST_NAME') + $t('message.TWO_DOTS')"
              />
              <EditableLabel
                v-model="value.lastName"
                class="clickable-hoverable"
                :placeholder="$t('message.CLICK_TO_TYPE')"
                :legend="$t('message.LAST_NAME') + $t('message.TWO_DOTS')"
              />
            </div>
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USER_NAMES_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <EditableLabel
              v-model="value.username"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.CONFIG_USERNAME') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USERNAME_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <EditableLabel
              v-model="value.email"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.EMAIL') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USER_EMAIL_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <AdvancedTeamPicker
              :value="[value.team]"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :legend="$t('message.CONFIG_PREFERRED_TEAM') + $t('message.TWO_DOTS')"
              display-all-teams
              single-value
              config
              use-editable-label
              @input="value.team = $event[0]"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USER_TEAM_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <AdvancedTeamPicker
              v-model="value.teams"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :legend="$t('message.TEAMS') + $t('message.TWO_DOTS')"
              display-all-teams
              config
              use-editable-label
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USER_TEAMS_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <AdvancedTeamPicker
              v-model="value.accesses"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :legend="$t('message.ACCESS') + $t('message.TWO_DOTS')"
              display-all-teams
              config
              use-editable-label
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ configAccessHint }}
            </div>
          </div>
          <div v-if="company.enableSaml || company.enableOidc" class="sep" />
          <div v-if="company.enableSaml || company.enableOidc" class="config-edition-modal__hinted-field">
            <EditableLabel
              v-model="value.ssoId"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.CONFIG_USER_SSO_ID') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_USER_SSO_ID_HINT') }}
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <CheckboxList
              v-model="value.roles"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :display-all-toggle="false"
              :items="allRoles"
              :legend="$t('message.CONFIG_USER_ROLES') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              <div v-html="$t('message.CONFIG_USER_ADMIN_ACCESS_HINT')" />
              <div class="generic-field-margin" v-html="$t('message.CONFIG_USER_SETTINGS_ACCESS_HINT')" />
              <div class="generic-field-margin" v-html="$t('message.CONFIG_USER_PROBLEMS_ACCESS_HINT')" />
            </div>
          </div>
          <div class="sep" />
          <div class="config-edition-modal__hinted-field">
            <!-- TODO: Make it disabled -->
            <EditableLabel
              v-model="value.companyInternalId"
              class="clickable-hoverable config-edition-modal__hinted-field__field"
              :placeholder="$t('message.CLICK_TO_TYPE')"
              :legend="$t('message.CONFIG_COMPANY_INTERNAL_ID') + $t('message.TWO_DOTS')"
            />
            <div class="field-hint config-edition-modal__hinted-field__hint">
              {{ $t('message.CONFIG_COMPANY_INTERNAL_ID_HINT') }}
            </div>
          </div>
          <button type="submit" class="action-btn" style="margin: 30px auto;display: block;">
            {{ $t('message.SAVE') }}
          </button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Modal view to edit a team or a user properties
 *
 * @vue-prop {Object} value - Team or user to edit
 * @vue-prop {Boolean} isTeam - Whether the object to edit is a team or a user
 */

import $ from 'jquery';
// Components
import AdvancedTeamPicker from '@/components/advanced-team-picker.vue';
import CloseButton from '@/components/close-button.vue';
import EditableLabel from '@/components/editable-label.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import CheckboxList from '@/components/checkbox-list.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { hierarchyColors } from '@/utils/config-utils';
import { calert, preventPastingStyles } from '@/utils/main';


export default {

  name: 'ConfigEditionModal',

  components: {
    AdvancedTeamPicker,
    CheckboxList,
    CloseButton,
    EditableLabel,
    EditableLabelRadio,
  },

  mixins: [mixinConfigPages],

  props: {
    value: {
      type: Object,
      required: true,
    },
    allUsers: {
      type: Array,
      required: true,
    },
    isTeam: Boolean,
  },

  data() {
    return {
      colors: hierarchyColors,
      allRoles: [
        { id: 2, label: this.$t('message.CONFIG_USER_ADMIN_ACCESS') },
        { id: 3, label: this.$t('message.CONFIG_USER_SETTINGS_ACCESS') },
        { id: 4, label: this.$t('message.CONFIG_USER_PROBLEMS_ACCESS') },
      ],
    };
  },

  computed: {
    /** Object: Team object corresponding to the 'team' param of the editedItem */
    editedItemTeam() {
      return this.viewMode === 1 && this.editedItem !== null
        ? this.teams.find(t => t.id === this.editedItem.team)
        : null;
    },
    /** String: Hint displayed in the edition of a user for the 'accesses' field */
    configAccessHint() {
      return this.$t('message.CONFIG_USER_ACCESSES_HINT', {
        teamName: this.value ? this.value.name : this.$t('message.CONFIG_THIS_USER_TEAM'),
      });
    },
    /** String: Error to display to prevent the edition. Null if no error */
    editionError() {
      if (this.supervisorTeamError !== null) {
        return this.supervisorTeamError;
      }
      if (this.supervisedTeamError !== null) {
        return this.supervisedTeamError;
      }
      return null;
    },
    /** Array: Array of IDs of all the parents at any level */
    allSupervisorTeamIds() {
      if (!this.value.supervisorTeamIds) {
        return [];
      }
      const directSupervisors = this.value.supervisorTeamIds
        .map(teamId => this.allTeams.find(t => t.id === teamId))
        .filter(sup => sup && sup.id);
      return directSupervisors.flatMap(team => team.parents).concat(this.value.supervisorTeamIds);
    },
    /** Array: Array of team objects matching the selected supervised teams */
    allSupervisedTeamIds() {
      if (!this.value.supervisedTeamIds) {
        return [];
      }
      const directSup = this.value.supervisedTeamIds
        .map(teamId => this.allTeams.find(t => t.id === teamId))
        .filter(sup => sup && sup.id);
      return directSup.flatMap(team => team.children || []).concat(this.value.supervisedTeamIds);
    },
    /** String: Message if there's an error in the teams hierarchy. Null otherwise */
    supervisorTeamError() {
      let redundantTeamId = this.allSupervisorTeamIds.find(supId => this.allSupervisedTeamIds.includes(supId));
      if (redundantTeamId) {
        let redundantTeam = this.allTeams.find(t => t.id === redundantTeamId);
        if (!this.value.supervisorTeamIds.includes(redundantTeamId)) {
          redundantTeamId = this.value.supervisorTeamIds.find(id => redundantTeam.children.includes(id));
          redundantTeam = this.allTeams.find(t => t.id === redundantTeamId);
        }
        return this.$t('message.SUPERVISOR_TEAM_ERROR', redundantTeam);
      }
      if (this.allSupervisorTeamIds.includes(this.value.id)) {
        return this.$t('message.SUPERVISOR_TEAM_SELF_ERROR');
      }
      return null;
    },
    /** String: Message if there's an error in the teams hierarchy. Null otherwise */
    supervisedTeamError() {
      let redundantTeamId = this.allSupervisedTeamIds.find(supId => this.allSupervisorTeamIds.includes(supId));
      if (redundantTeamId) {
        let redundantTeam = this.allTeams.find(t => t.id === redundantTeamId);
        if (!this.value.supervisedTeamIds.includes(redundantTeamId)) {
          redundantTeamId = this.value.supervisedTeamIds.find(id => redundantTeam.parents.includes(id));
          redundantTeam = this.allTeams.find(t => t.id === redundantTeamId);
        }
        return this.$t('message.SUPERVISED_TEAM_ERROR', redundantTeam);
      }
      if (this.allSupervisedTeamIds.includes(this.value.id)) {
        return this.$t('message.SUPERVISOR_TEAM_SELF_ERROR');
      }
      return null;
    },
    /** Array: Tree-like array => each element hasa 'teams' property which is an array of other teams */
    teamsTree() {
      return this.$store.getters.allTeamsTree || [];
    },
    allTeams() {
      return this.$store.getters.allTeamsTreeFlattened;
    },
  },

  watch: {
    value: {
      deep: true,
      handler(newItem) {
        if (!this.isTeam && newItem !== null) {
          // The 'preferred team' must be in the array of teams this user is a member of
          if (!newItem.teams.includes(newItem.team)) {
            newItem.teams.push(newItem.team);
          }
        }
      },
    },
  },

  mounted() {
    this.$nextTick(preventPastingStyles);
    $(document).on(this.escKeyupEventName, () => {
      this.$emit('input', null);
    });
  },

  beforeDestroy() {
    $(document).off(this.escKeyupEventName);
  },

  methods: {
    save() {
      if (this.editionError) {
        calert(this.editionError);
        return;
      }
      this.$emit('input', this.value);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.config-edition-modal {

  &__hinted-field {
    display: flex;
    align-items: center;

    &__hint {
      flex: 1 0 60%;
      min-width: 0px;
      width: 60%;

      &__error {
        color: $color-red-bad;
      }
    }
    &__field {
      flex: 1 0 35%;
      width: 35%;
      margin-right: 5%;

      &.hierarchy-wrapper {
        position: relative;

        .dot {
          position: absolute;
          top: 0.8em;
          left: -0.8em;
          margin: 0;
          display: block;
          width: 0.4em;
          height: 0.4em;
          border-radius: 1em;
        }
      }
    }
  }
  .sep {
    background: #bcbcbc;
    width: 90%;
    margin: .7em 5% .5em 5%;
    display: block;
  }
  .clickable-hoverable {
    padding: 0.15em 0px;
  }
}
</style>
